import exifr from 'exifr'

/**
 * Extract the earliest capture timestamp across the given image files by reading
 * only the EXIF metadata segment (fast — does not decode the image). Returns the
 * earliest DateTimeOriginal/CreateDate found, or null. Never throws.
 */
export async function extractCaptureDate(files: File[]): Promise<Date | null> {
  const dates: Date[] = []
  await Promise.all(
    files.map(async (file) => {
      try {
        const meta = await exifr.parse(file, { pick: ['DateTimeOriginal', 'CreateDate'] })
        const raw = meta?.DateTimeOriginal ?? meta?.CreateDate
        if (raw instanceof Date && !Number.isNaN(raw.getTime())) dates.push(raw)
      } catch {
        // ignore files without/with unreadable EXIF
      }
    })
  )
  if (dates.length === 0) return null
  return dates.reduce((a, b) => (a.getTime() <= b.getTime() ? a : b))
}
